// TSS vite/06 — env-driven config. Throws at boot if required vars are missing.

import { mixedContentProblem } from '../../core/utils/endpoint';

const required = ['VITE_API_ENDPOINT'];
const missing = required.filter(k => !import.meta.env[k]);
if (missing.length) {
    throw new Error(`[boot] missing env: ${missing.join(', ')}`);
}

// Y que además se pueda alcanzar, no solo que esté escrita.
//
// `VITE_API_ENDPOINT` se hornea en el bundle, así que un `http://` en un panel
// servido por `https://` es un error que se comete una vez al construir y se
// descubre una vez por usuario: el navegador bloquea cada llamada como
// contenido mixto, y no hay error que la aplicación pueda ver. La pantalla se
// queda esperando y el único rastro es una línea de consola que nadie mira.
//
// Un throw acá lo convierte en lo que es —una configuración mal hecha— y lo
// hace en el mismo lugar y por la misma razón que la comprobación de arriba.
if (typeof window !== 'undefined') {
    const problem = mixedContentProblem(
        import.meta.env.VITE_API_ENDPOINT,
        window.location.protocol,
    );
    if (problem) throw new Error(problem);
}

export const api = {
    endpoint: import.meta.env.VITE_API_ENDPOINT,
};

export const cdn = {
    public: import.meta.env.VITE_CDN_PUBLIC || null,
};

export const meta = {
    projectName: import.meta.env.VITE_PROJECT_NAME || 'Trianametria App',
};

// Feature switches. Off unless the env says otherwise, on purpose: a screen
// must not offer something the backend cannot answer.
//
// githubLogin — mastermind_core publishes five auth routes today (login,
// logout, refresh, me, change-password) and NONE of them is OAuth. The whole
// frontend side of the GitHub flow is written and waiting; the switch turns
// on the day the backend exposes GET /auth/github. Until then the button does
// not render, because a button that answers 404 is worse than no button.
export const features = {
    githubLogin: import.meta.env.VITE_GITHUB_LOGIN === 'true',
};
